import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

const useUIStore = create(
  persist(
    (set) => ({
      mode: (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) ? 'dark' : 'dark',
      toggleMode: () => set((s) => ({ mode: s.mode === 'dark' ? 'light' : 'dark' })),
    }),
    {
      name: 'mesum_ui_store',
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ mode: s.mode })
    }
  )
);

export default useUIStore;
